import { Box, Stack, VisuallyHidden } from "@chakra-ui/react";

/** Id of the label that `GroupBase` renders for the control with `fieldId`. */
export const groupLabelId = (fieldId: string) => `${fieldId}-label`;
/** Id of the error or caption that `GroupBase` renders for `fieldId`. */
export const groupMessageId = (fieldId: string) => `${fieldId}-message`;

export interface GroupProps {
  name?: string;
  label?: React.ReactNode;
  error?: string | null;
  isDisabled?: boolean;
  largerLabel?: boolean;
  hideLabel?: boolean;
  caption?: React.ReactNode;
  fieldId?: string;
  [x: string]: any;
}

interface GroupBaseProps extends GroupProps {
  children: React.ReactNode;
}

export const GroupBase = ({
  name,
  label,
  error,
  caption,
  isDisabled,
  children,
  largerLabel,
  hideLabel,
  fieldId,
  ...rest
}: GroupBaseProps) => (
  <Stack direction="column" spacing="3" {...rest}>
    {label &&
      (!hideLabel ? (
        <Box
          as="label"
          id={fieldId && groupLabelId(fieldId)}
          htmlFor={fieldId}
          textStyle={!largerLabel ? "base" : "subtitle4Bold"}
          color={isDisabled ? "fg.muted" : "fg.emphasized"}
        >
          {label}
        </Box>
      ) : (
        <VisuallyHidden
          as="label"
          id={fieldId && groupLabelId(fieldId)}
          htmlFor={fieldId}
        >
          {label}
        </VisuallyHidden>
      ))}
    {children}
    {error ? (
      <Box
        id={fieldId && groupMessageId(fieldId)}
        textStyle="caption"
        color="error.fg"
        data-cy={`error-messages-${name}`}
        textAlign="left"
      >
        <>{error}</>
      </Box>
    ) : caption ? (
      <Box
        id={fieldId && groupMessageId(fieldId)}
        textStyle="caption"
        data-cy={`caption-messages-${name}`}
      >
        <>{caption}</>
      </Box>
    ) : null}
  </Stack>
);
